import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { SSO_DASHBOARD_URL, GROWTHPAL_ACCESS_TOKEN } from '../store/authStore'

export default function LandingPage() {
  const navigate = useNavigate()

  useEffect(() => {
    const token = localStorage.getItem(GROWTHPAL_ACCESS_TOKEN)
    if (token) {
      navigate('/companies', { replace: true })
    } else {
      window.location.href = `${SSO_DASHBOARD_URL}?redirectTo=${encodeURIComponent(window.location.href)}`
    }
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50">
      <div className="animate-pulse text-neutral-400">Redirecting...</div>
    </div>
  )
}
